import axios from '@/api/config/request'
import config from '@/config/index'

// 按类型分组获取文章列表
export function getArticleGroupList(params) {
  return axios({
    url: `${config.POWER_CABLE_BASE}/article/group/list/${params.size}`,
    method: 'get'
  })
}
// 文章详情--根据id显示
export function getArticleInfoById(id) {
  return axios({
    url: `${config.POWER_CABLE_BASE}/article/view/${id}`,
    method: 'get',
  })
}

// 文章管理--条件查询分页
export function getArticleList(params) {
  return axios({
    url: `${config.POWER_CABLE_BASE}/article/page`,
    method: 'get',
    params:{...params,display:true}
  })
}
export function getHotNews(){
  return axios({
    url: `${config.POWER_CABLE_BASE}/article/hotNews`,
    method: 'get',
  })
}
